namespace Matrix.Data {
    export interface AccountGroupAccountForm {
        AccountCode: Serenity.ServiceLookupEditor;
        AccountGroupCode: Serenity.LookupEditor;
        CreatedBy: StaticTextBlock;
        CreatedWhen: ReadOnlyDateTime;
        UpdatedBy: StaticTextBlock;
        UpdatedWhen: ReadOnlyDateTime;
        Version: StaticTextBlock;
    }

    export class AccountGroupAccountForm extends Serenity.PrefixedContext {
        static formKey = 'Data.AccountGroupAccount';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!AccountGroupAccountForm.init)  {
                AccountGroupAccountForm.init = true;

                var s = Serenity;
                var w0 = s.ServiceLookupEditor;
                var w1 = s.LookupEditor;
                var w2 = StaticTextBlock;
                var w3 = ReadOnlyDateTime;

                Q.initFormType(AccountGroupAccountForm, [
                    'AccountCode', w0,
                    'AccountGroupCode', w1,
                    'CreatedBy', w2,
                    'CreatedWhen', w3,
                    'UpdatedBy', w2,
                    'UpdatedWhen', w3,
                    'Version', w2
                ]);
            }
        }
    }
}
